// @motorway/mw-lib-validators@1.9.1
// https://github.com/motorway/mw-lib-validators/blob/013f7b6f6c22e411d2d314cb862bf56e10af343c/src/index.ts

export const getNormalisedPhone = (value: string) => String(value).replace(/[()\s]/g, '');

export const getNumberWithoutPrefix = (normalisedPhone: string) => normalisedPhone.replace(/^(0044|\+44|0)/, '');

export const isValidMobilePhone = (phoneNumber: string): boolean => /^7\d{8,9}$/.test(phoneNumber);

export const isValidLandline = (phoneNumber: string): boolean => /^[12]\d{8,9}$/.test(phoneNumber);

export const isValidCommercialLine = (phoneNumber: string): boolean => /^(80|84|87)\d{7,8}$/.test(phoneNumber);

export const isValidNonGeoCommercialLine = (phoneNumber: string): boolean => /^3\d{8,9}$/.test(phoneNumber);

/**
 * Prefixes are 0, +44, 0044 or none, and number is between 9 and 10 digits (excluding the prefix)
 * First digits can be:
 *   7 for mobile, or 1 or 2 for landline, followed by 8 or 9 digits
 *   80, 84 or 87 for commercial lines, followed by 7 or 8 digits
 *   3 for non geographical commercial lines, followed by 8 or 9 digits
 */
export const isPhoneValid = (value: string): boolean => {
  const normalizedPhone = getNormalisedPhone(value);

  const numberWithoutPrefix = getNumberWithoutPrefix(normalizedPhone);
  return (
    isValidCommercialLine(numberWithoutPrefix)
    || isValidMobilePhone(numberWithoutPrefix)
    || isValidLandline(numberWithoutPrefix)
    || isValidNonGeoCommercialLine(numberWithoutPrefix)
  );
};

/**
 * Prefixes are 0, +44, 0044 or none, and number is between 9 and 10 digits (excluding the prefix)
 * First digits can be:
 *   7 for mobile followed by 8 or 9 digits
 */
export const isMobilePhoneValid = (value: string): boolean => {
  const normalizedPhone = getNormalisedPhone(value);

  const numberWithoutPrefix = getNumberWithoutPrefix(normalizedPhone);
  return isValidMobilePhone(numberWithoutPrefix);
};
